const RESOURCE_TYPE = [
    {
        name: 'Freepik',
        resourceType: 1,
        logo: 'https://cdn-icons-png.flaticon.com/512/1841/1841784.png'
    }
]

export default RESOURCE_TYPE;